import actions from './moduleAuthActions.js'

export default {
	namespaced: true,
    actions: actions,
}
